module.exports = __webpack_public_path__ + "static/img/shareBtn.4dade42.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/shareBtn.png
// module id = MzDk
// module chunks = 0